import { vaxAdminApi } from './Endpoints'

export const runForceSync = (customerKey: string, customerEnv: string) =>
  vaxAdminApi.get(`/proxy/${customerKey}/${customerEnv}/secure/sync`).then(response => response.data)
